import React from 'react';

import styles from './userWatchlistPageStyles';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import TickerSearchAutocompleteContainer from 'buyside/components/container/UserAccount/TickerSearchAutocompleteContainer';
import TickerUploader from 'buyside/components/presentation/TickerUploader/tickerUploader';

class TickerSearchSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // --- necessary state for autocomplete component
      isValidTicker: false,
      selectedItem: null,
      suggestions: [],
      tickerValue: '',
      //
      assetData: null, // data for the asset returned from EDM search
      loadingAsset: false, // asset modal info loading
      alreadyFollowing: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const followId = this.state.assetData.entityId;
    if (this.props.userTickerEntityIds.includes(followId)) {
      this.setState({ alreadyFollowing: true });
      setTimeout(() => {
        this.setState({ alreadyFollowing: false });
      }, 5000); // The message should be displayed temporarily - 22 Apr 2019 (TMA)
    } else {
      this.props
        .followEntity({ followId })
        .then(() => this.setState({ assetData: null, tickerValue: '' }));
    }
  }

  render() {
    const { suggestions, tickerValue, loadingAsset, assetData, alreadyFollowing } = this.state;
    return (
      <div>
        <div>Look up a security by symbol or name:</div>
        <div className={styles.tickerInput}>
          <TickerSearchAutocompleteContainer
            tickerValue={tickerValue}
            setParentState={args => this.setState(args)}
            suggestions={suggestions}
            updateSuggestions={suggestions => this.setState({ suggestions })}
          />
        </div>
        {loadingAsset && (
          <div>
            <LoadingSpinner size="nano" />
            <span>Loading Ticker...</span>
          </div>
        )}
        {!loadingAsset && assetData && (
          <div>
            <h4>{assetData.entity.name}</h4>
          </div>
        )}
        <div className={styles.buttonContainer}>
          <Button
            disabled={!assetData}
            isLoading={loadingAsset}
            onClick={this.handleSubmit}
            text="Add This Ticker"
            analyticsTag="add-this-ticker"
            type={BUTTON_TYPES.PRIMARY}
          />
          <TickerUploader />
          {alreadyFollowing && (
            <span className={styles.duplicateMsg}>The ticker already exists in your list.</span>
          )}
        </div>
      </div>
    );
  }
}

export default TickerSearchSection;
